module.exports = "/images/bloodborne-disease@3x.png?1fcdbe1f37bd9cb4e768976068ea6006";